import React, { Component } from "react"
import styled from "styled-components"
import ReactPopup from "reactjs-popup"
import colors from "../../styles/colors"
import CloseIcon from "../../resources/img/ui/popup/popup-close.svg"
import RingSizeChart from "../../resources/img/pdp/noma-alphabet-chart.jpg"
import RingSizeChartMobile from "../../resources/img/pdp/noma-alphabet-chart.jpg"
import { withTranslation } from "gatsby-plugin-react-i18next"

const PopUpContent = styled.div``

const Close = styled.img`
  height: 16px;
  width: 16px;
  position: absolute;
  right: 20px;
  top: 26px;
  cursor: pointer;
`

const SizeChartImg = styled.img`
  max-width: 100%;
  display: block;
  margin: 0 auto;
`

const contentStyle = {
  width: "90%",
  margin: "auto",
  maxWidth: "700px",
  background: `${colors.white}`,
  border: `2px solid ${colors.green}`,
  paddingTop: "46px",
  paddingBottom: "47px",
  paddingLeft: "20px",
  paddingRight: "20px",
  boxSizing: "border-box",
  height: "auto",
  overflow: "auto",
  position: "relative",
}

const contentStyleMobile = {
  width: "100%",
  maxWidth: "375px",
  margin: "auto",
  marginTop: "60px",
  background: `${colors.white}`,
  border: `2px solid ${colors.green}`,
  paddingTop: "46px",
  paddingBottom: "20px",
  paddingLeft: "20px",
  paddingRight: "20px",
  height: "auto",
  overflow: "auto",
  position: "relative",
}

const overlayStyle = {
  overflowY: "auto",
  background: "rgba(248, 245, 243, 0.9)",
}

const overlayStyleMobile = {
  overflowY: "auto",
  background: "rgba(248, 245, 243, 0.9)",
}

class Popup extends Component {
  state = {
    width: 0,
    height: 0,
  }

  componentDidMount = () => {
    if (typeof window !== "undefined") {
      this.updateWindowDimensions()
      window.addEventListener("resize", this.updateWindowDimensions)
    }
  }

  componentWillUnmount = () => {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.updateWindowDimensions)
    }
  }

  updateWindowDimensions = () => {
    if (typeof window !== "undefined") {
      this.setState({ width: window.innerWidth, height: window.innerHeight })
    }
  }

  getContentStyle = () => {
    if (this.state.width >= 700) {
      return contentStyle
    } else if (this.state.width < 700) {
      return contentStyleMobile
    }
  }

  render() {
    const { open, handlePopup, t } = this.props

    return (
      <ReactPopup
        contentStyle={this.getContentStyle()}
        overlayStyle={
          this.state.width >= 699 ? overlayStyle : overlayStyleMobile
        }
        open={open}
        closeOnDocumentClick
        onClose={() => handlePopup(false)}
      >
        <div>
          <PopUpContent>
            <SizeChartImg
              src={
                this.state.width >= 699 ? RingSizeChart : RingSizeChartMobile
              }
            />
          </PopUpContent>
          <Close
            src={CloseIcon}
            onClick={() => handlePopup(false)}
            alt={t("core.close")}
          />
        </div>
      </ReactPopup>
    )
  }
}

export default withTranslation()(Popup)
